// @flow

// begin auth actions
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
// export const SET_TOKEN = 'SET_TOKEN';
export const INITIATE_LOGIN = 'INITIATE_LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CHECK_SESSION = 'CHECK_SESSION';
export const RESET_CHECK_SESSION = 'RESET_CHECK_SESSION';
export const SESSION_CHECKED_SUCCESS = 'SESSION_CHECKED_SUCCESS';
export const SESSION_CHECKED_ERROR = 'SESSION_CHECKED_ERROR';
export const SET_SESSION_ID = 'SET_SESSION_ID';
export const REQUEST_OTP = 'REQUEST_OTP';
export const INITIATE_REQUEST_OTP = 'INITIATE_REQUEST_OTP';
export const REQUEST_OTP_SUCCESS = 'REQUEST_OTP_SUCCESS';
export const REQUEST_OTP_ERROR = 'REQUEST_OTP_ERROR';
export const RESET_OTP_REQUEST = 'RESET_OTP_REQUEST';
export const SETTING_MPIN = 'SETTING_MPIN';
export const SETTING_MPIN_SUCCESS = 'SETTING_MPIN_SUCCESS';
export const SETTING_MPIN_ERROR = 'SETTING_MPIN_ERROR';
export const VALIDATE_OTP = 'VALIDATE_OTP';
export const RESET_SESSION = 'RESET_SESSION';
export const TOKEN_AUTHENTICATE = 'TOKEN_AUTHENTICATE';
export const TOKEN_AUTHENTICATE_SUCCESS = 'TOKEN_AUTHENTICATE_SUCCESS';
export const TOKEN_AUTHENTICATE_ERROR = 'TOKEN_AUTHENTICATE_ERROR';
export const TOGGLE_SIGNUP_DLG = 'TOGGLE_SIGNUP_DLG';
export const FETCH_SESSION_ID = 'FETCH_SESSION_ID';
export const FETCH_SESSION_ID_SUCCESS = 'FETCH_SESSION_ID_SUCCESS';
export const CANCEL_FETCH_SESSION_ID = 'CANCEL_FETCH_SESSION_ID';
export const UPDATE_SESSION_DATA = 'UPDATE_SESSION_DATA';
// end auth actions

// begin pod actions
export const FETCH_PODS = 'FETCH_PODS';
export const INITIATE_FETCH_PODS = 'INITIATE_FETCH_PODS';
export const FETCH_PODS_SUCCESS = 'FETCH_PODS_SUCCESS';
export const FETCH_PODS_ERROR = 'FETCH_PODS_ERROR';
export const SELECT_POD = 'SELECT_POD';
export const RESET_SELECT_POD = 'RESET_SELECT_POD';
export const FETCH_POD_BANNERS = 'FETCH_POD_BANNERS';
export const FETCH_POD_BANNERS_SUCCESS = 'FETCH_POD_BANNERS_SUCCESS';
export const FETCH_POD_BANNERS_ERROR = 'FETCH_POD_BANNERS_ERROR';
export const FETCH_AFFILIATE = 'FETCH_AFFILIATE';
export const FETCH_AFFILIATE_SUCCESS = 'FETCH_AFFILIATE_SUCCESS';
export const FETCH_AFFILIATE_ERROR = 'FETCH_AFFILIATE_ERROR';
export const SET_AFFILIATE_DATA = 'SET_AFFILIATE_DATA';
// end pod actions

// begin sku actions
export const FETCH_SKUS = 'FETCH_SKUS';
export const INITIATE_FETCH_SKUS = 'INITIATE_FETCH_SKUS';
export const FETCH_SKUS_SUCCESS = 'FETCH_SKUS_SUCCESS';
export const FETCH_SKUS_ERROR = 'FETCH_SKUS_ERROR';
export const SELECT_SKU = 'SELECT_SKU';
export const UPDATE_SKU_PURCHASE_COUNT = 'UPDATE_SKU_PURCHASE_COUNT';
export const RESET_SKUS = 'RESET_SKUS';

// end sku actions

// begin virtual shelf actions
export const FETCH_VSHELF = 'FETCH_VSHELF';
export const FETCH_VSHELF_SUCCESS = 'FETCH_VSHELF_SUCCESS';
export const FETCH_VSHELF_ERROR = 'FETCH_VSHELF_ERROR';
export const NOTIFY_USER = 'NOTIFY_USER';
export const UPDATE_VSKU_PURCHASE_COUNT = 'UPDATE_VSKU_PURCHASE_COUNT';
export const FETCH_AFFL_SKUS = 'FETCH_AFFL_SKUS';
export const FETCH_AFFL_SKUS_SUCCESS = 'FETCH_AFFL_SKUS_SUCCESS';
export const FETCH_AFFL_SKUS_ERROR = 'FETCH_AFFL_SKUS_ERROR';
export const RESET_VSHELF = 'RESET_VSHELF';

// end virtual shelf actions



// begin cart actions
export const UPDATE_CART = 'UPDATE_CART';
export const UPDATE_CART_SUCCESS = 'UPDATE_CART_SUCCESS';
export const UPDATE_CART_ERROR = 'UPDATE_CART_ERROR';
export const TOGGLE_RESET_CART = 'TOGGLE_RESET_CART';
export const RESET_CART = 'RESET_CART';
export const ADD_LAST_TRANSACTION = 'ADD_LAST_TRANSACTION';
export const CLEAR_LAST_TRANSACTION = 'CLEAR_LAST_TRANSACTION';
export const THROTTLE_SAVE_CART = 'THROTTLE_SAVE_CART';
export const SAVE_CART = 'SAVE_CART';
export const INITIATE_SAVE_CART = 'INITIATE_SAVE_CART';
export const SAVE_CART_SUCCESS = 'SAVE_CART_SUCCESS';
export const SAVE_CART_ERROR = 'SAVE_CART_SUCCESS';
export const FETCH_CART = 'FETCH_CART';
export const FETCH_CART_SUCCESS = 'FETCH_CART_SUCCESS';
export const FETCH_CART_ERROR = 'FETCH_CART_ERROR';
export const SET_CART = 'SET_CART';
export const SET_CART_ORDER_ID = 'SET_CART_ORDER_ID';
export const SET_TRANSACTION_VALUE = 'SET_TRANSACTION_VALUE';
// end cart actions

// begin snackbar actions
export const TOGGLE_SNACKBAR = 'TOGGLE_SNACKBAR';
// end snackbar actions

// begin user actions
export const SET_USER = 'SET_USER';
export const RESET_USER = 'RESET_USER';
export const FETCH_LATLNG = 'FETCH_LATLNG';
export const FETCH_LATLNG_SUCCESS = 'FETCH_LATLNG_SUCCESS';
export const FETCH_LATLNG_ERROR = 'FETCH_LATLNG_ERROR';
export const FETCH_USER_DETAILS = 'FETCH_USER_DETAILS';
export const FETCH_USER_DETAILS_SUCCESS = 'FETCH_USER_DETAILS_SUCCESS';
export const FETCH_USER_DETAILS_ERROR = 'FETCH_USER_DETAILS_ERROR';
// end user actions

// begin payment actions
export const FETCH_PAYMENT_METHODS = 'FETCH_PAYMENT_METHODS';
export const INITIATE_FETCH_PAYMENT_METHODS = 'INITIATE_FETCH_PAYMENT_METHODS';
export const FETCH_PAYMENT_METHODS_SUCCESS = 'FETCH_PAYMENT_METHODS_SUCCESS';
export const FETCH_PAYMENT_METHODS_ERROR = 'FETCH_PAYMENT_METHODS_ERROR';
export const SELECT_PAYMENT_METHOD = 'SELECT_PAYMENT_METHOD';
export const LINK_PAYMENT_SEND_OTP = 'LINK_PAYMENT_SEND_OTP';
export const LINK_PAYMENT_SEND_OTP_SUCCESS = 'LINK_PAYMENT_SEND_OTP_SUCCESS';
export const LINK_PAYMENT_METHOD = 'LINK_PAYMENT_METHOD';
export const LINK_PAYMENT_METHOD_SUCCESS = 'LINK_PAYMENT_METHOD_SUCCESS';
export const MAKE_PAYMENT = 'MAKE_PAYMENT';
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
export const PAYMENT_ERROR = 'PAYMENT_ERROR';
export const RESET_PAYMENT = 'RESET_PAYMENT';
export const PAYTM_ADD_MONEY_RES = 'PAYTM_ADD_MONEY_RES';
export const OPEN_CARD_CVV = 'OPEN_CARD_CVV';
export const SET_PAYMENT = 'SET_PAYMENT';
export const CAPTURE_PAYMENT = 'CAPTURE_PAYMENT';
export const FETCH_PENDING_BALANCE = 'FETCH_PENDING_BALANCE';
export const FETCH_PENDING_BALANCE_SUCCESS = 'FETCH_PENDING_BALANCE_SUCCESS';
export const FETCH_PENDING_BALANCE_ERROR = 'FETCH_PENDING_BALANCE_ERROR';
export const NEUU_WALLET_MAKE_PAYMENT = 'NEUU_WALLET_MAKE_PAYMENT';
export const POOL_PAYMENT_STATUS = 'POOL_PAYMENT_STATUS';
export const CANCEL_POOL_PAYMENT_STATUS = 'CANCEL_POOL_PAYMENT_STATUS';
export const UPI_COLLECT_PAYMENT = 'UPI_COLLECT_PAYMENT';
export const SELECTED_PAYMENT_ERROR = 'SELECTED_PAYMENT_ERROR';
export const RESET_VERIFICATION = 'RESET_VERIFICATION';
export const EDIT_UPI_VPA = 'EDIT_UPI_VPA';
export const CLEAR_UPI_VPA = 'CLEAR_UPI_VPA';
export const CLEAR_UPI_VPA_SUCCESS = 'CLEAR_UPI_VPA_SUCCESS';
export const CLEAR_UPI_VPA_ERROR = 'CLEAR_UPI_VPA_ERROR';
export const ADD_MONEY_PG = 'ADD_MONEY_PG';
export const SHOW_PAYMENT_GATEWAY = 'SHOW_PAYMENT_GATEWAY';
// export const ADD_MONEY_PG_SUCCESS = 'ADD_MONEY_PG_SUCCESS';
// export const ADD_MONEY_PG_ERROR = 'ADD_MONEY_PG_ERROR';
// end payment actions

// begin order actions
export const FETCH_ORDERS = 'FETCH_ORDERS';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_ERROR = 'FETCH_ORDERS_ERROR';
export const FETCH_LAST_ORDER = 'FETCH_LAST_ORDER';
export const FETCH_LAST_ORDER_SUCCESS = 'FETCH_LAST_ORDER_SUCCESS';
export const FETCH_LAST_ORDER_ERROR = 'FETCH_LAST_ORDER_ERROR';
export const FETCH_ORDER_INVOICE = 'FETCH_ORDER_INVOICE';
export const FETCH_ORDER_INVOICE_SUCCESS = 'FETCH_ORDER_INVOICE_SUCCESS';
export const FETCH_ORDER_INVOICE_ERROR = 'FETCH_ORDER_INVOICE_ERROR';
export const SELECT_ORDER = 'SELECT_ORDER';
export const SET_PENDING_ORDERS = 'SET_PENDING_ORDERS';
export const SYNC_PENDING_ORDERS = 'SYNC_PENDING_ORDERS';
export const CANCEL_SYNC_PENDING_ORDERS = 'CANCEL_SYNC_PENDING_ORDERS';
export const PENDING_ORDERS_SUCCESS = 'FETCH_PENDING_ORDERS_SUCCESS';
export const PENDING_ORDERS_ERROR = 'FETCH_PENDING_ORDERS_ERROR';
export const CANCEL_PENDING_ORDER = 'CANCEL_PENDING_ORDER';
export const CANCEL_PENDING_ORDER_SUCCESS = 'CANCEL_PENDING_ORDER_SUCCESS';
export const DEBOUNCE_FETCH_PAYMENT_METHODS = 'DEBOUNCE_FETCH_PAYMENT_METHODS';
export const POOL_ACTIVE_ORDER = 'POOL_ACTIVE_ORDER';
export const CANCEL_POOL_ACTIVE_ORDER = 'CANCEL_POOL_ACTIVE_ORDER';
export const CANCEL_VS_ORDER = 'CANCEL_VS_ORDER';
export const POOL_ALL_LIVE_ORDERS = 'POOL_ALL_LIVE_ORDERS';
export const CANCEL_POOL_ALL_LIVE_ORDERS = 'CANCEL_POOL_ALL_LIVE_ORDERS';
export const SET_ALL_LIVE_ORDERS = 'SET_ALL_LIVE_ORDERS';
// Real-time WebSocket actions
export const UPDATE_ORDER_STATUS_REALTIME = 'UPDATE_ORDER_STATUS_REALTIME';
export const SET_SOCKET_CONNECTION = 'SET_SOCKET_CONNECTION';
export const ADD_REALTIME_STATUS = 'ADD_REALTIME_STATUS';
export const CLEAR_REALTIME_STATUSES = 'CLEAR_REALTIME_STATUSES';
export const ADD_MACHINE_MESSAGE = 'ADD_MACHINE_MESSAGE';
// end order actions

// begin passbook actions
export const FETCH_PASSBOOK = 'FETCHING_PASSBOOK';
export const FETCH_PASSBOOK_SUCCESS = 'FETCH_PASSBOOK_SUCCESS';
export const FETCH_PASSBOOK_ERROR = 'FETCH_PASSBOOK_ERROR';
// end passbook actions

// begin feedback action
export const FETCH_FEEDBACK_FORM = 'FETCH_FEEDBACK_FORM';
export const FETCH_FEEDBACK_FORM_SUCCESS = 'FETCH_FEEDBACK_FORM_SUCCESS';
export const FETCH_FEEDBACK_FORM_ERROR = 'FETCH_FEEDBACK_FORM_ERROR';
export const SUBMIT_FEEDBACK = 'SUBMIT_FEEDBACK';
export const SUBMIT_FEEDBACK_SUCCESS = 'SUBMIT_FEEDBACK_SUCCESS';
export const SUBMIT_FEEDBACK_ERROR = 'SUBMIT_FEEDBACK_ERROR';
// end feedback action

// begin service worker action
export const TRIGGER_UPDATE_APP = 'TRIGGER_UPDATE_APP';
export const UPDATE_APP = 'UPDATE_APP';
export const HIDE_INSTALL_BANNER = 'HIDE_INSTALL_BANNER';
export const APP_INSTALLED = 'APP_INSTALLED';
export const SHOW_INSTALL_PROMPT = 'SHOW_INSTALL_PROMPT';
export const HIDE_INSTALL_PROMPT = 'HIDE_INSTALL_PROMPT';
export const TRIGGER_INSTALL = 'TRIGGER_INSTALL';
// end service worker action

// begin log action
export const LOG_TO_SERVER = 'LOG_TO_SERVER';
// end log action

// begin wallet action
export const FETCH_WALLET = 'FETCH_WALLET';
export const FETCH_WALLET_SUCCESS = 'FETCH_WALLET_SUCCESS';
export const FETCH_WALLET_ERROR = 'FETCH_WALLET_ERROR';
export const SET_WALLET_AMOUNT = 'SET_WALLET_AMOUNT';
export const LOAD_WALLET = 'LOAD_WALLET';
export const LOAD_WALLET_SUCCESS = 'LOAD_WALLET_SUCCESS';
export const LOAD_WALLET_ERROR = 'LOAD_WALLET_ERROR';
export const RESET_LOAD_WALLET = 'RESET_LOAD_WALLET';
export const CAPTURE_WALLET_PAYMENT = 'CAPTURE_WALLET_PAYMENT';
export const FETCH_WALLET_REFUND_LIST = 'FETCH_WALLET_REFUND_LIST';
export const WALLET_REFUND_LIST_SUCCESS = 'WALLET_REFUND_LIST_SUCCESS';
export const WALLET_REFUND_LIST_ERROR = 'WALLET_REFUND_LIST_ERROR';
export const PROCESS_WALLET_REFUND = 'PROCESS_WALLET_REFUND';
export const WALLET_REFUND_SUCCESS = 'WALLET_REFUND_SUCCESS';
export const WALLET_REFUND_ERROR = 'WALLET_REFUND_ERROR';
export const RESET_WALLET_REFUND = 'RESET_WALLET_REFUND';
export const POOL_WALLET_LOAD = 'POOL_WALLET_LOAD';
export const CANCEL_POOL_WALLET_LOAD = 'CANCEL_POOL_WALLET_LOAD';
export const LOAD_WALLET_UPI = 'LOAD_WALLET_UPI';
export const PARTIAL_REFUND = 'PARTIAL_REFUND';
// end wallet action

// rating actions
export const SUBMIT_RATING = 'SUBMIT_RATING';
export const TOGGLE_RATING_DLG = 'TOGGLE_RATING_DLG';
export const SET_RATING_PARAMS = 'SET_RATING_PARAMS';
// end rating actions

// begin tips action
export const TOGGLE_TIPS = 'TOGGLE_TIPS';
// end tips action

// begin delivery action
export const FETCH_DELIVERY_ADD = 'FETCH_DELIVERY_ADD';
export const FETCH_DELIVERY_ADD_SUCCESS = 'FETCH_DELIVERY_ADD_SUCCESS';
export const FETCH_DELIVERY_ADD_ERROR = 'FETCH_DELIVERY_ERROR';
export const SAVE_DELIVERY_ADD = 'SAVE_DELIVERY_ADD';
export const SAVE_DELIVERY_ADD_SUCCESS = 'SAVE_DELIVERY_ADD_SUCCESS';
export const SAVE_DELIVERY_ADD_ERROR = 'SAVE_DELIVERY_ADD_ERROR';
export const SET_DELIVERY_ADD = 'SET_DELIVERY_ADD';
// end delivery action

// begin log actions
export const LOG_EVENT = 'LOG_EVENT';
export const LOG_USER_EVENT = 'LOG_USER_EVENT';
// end log actions

// begin app actions
export const START_SYNC = 'START_SYNC';
export const COMPLETE_SYNC = 'COMPLETE_SYNC';
export const SYNC_ERROR = 'SYNC_ERROR';
// end log actions



export type Action = {|
	type: string,
	payload?: any,
|};

export type CartData = {
	skuData: any,
	isSampling: boolean,
	qty: number,
	amount: number,
	action: 'ADD' | 'REMOVE',
	imei: string,
	machine: any,
};

export const SAMPLING_KEY = '_SAMPLING';

export type Address = {
	label?: string,
	flat_building?: string,
	address: string,
	area_name?: string,
	imei?: string,
	id?: string,
	geocode: string,
};
